import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import SavingIndicator from '../components/common/saving-indicator'

class Saving extends Component {
  render() {
    const { pathname, event, rider } = this.props

    return <SavingIndicator savingInstance={pathname.includes('event') ? {saving: event.isSaving} : {saving: rider.saving}} />
  }
}

Saving.propTypes = {
  pathanme: PropTypes.string,
  state: PropTypes.object,
  rider: PropTypes.object
}

Saving.defaultProps = {
  pathanme: '',
  state: {},
  rider: {}
}

export const mapStateToProps = (state) => {
  return {
    event: state.event,
    rider: state.rider
  }
}

export default connect(mapStateToProps, undefined)(Saving)



// WEBPACK FOOTER //
// ./src/containers/saving.js